import { Enums } from "@flightscope/baseball-stats";
import colors from "./helpers/colors";

/** @type {ColorMap} */
export default {
  [Enums.QualityOfContact.Barrel.key]: colors.red.thunderbird,
  [Enums.QualityOfContact.SolidContact.key]: colors.red.newYorkPink,
  [Enums.QualityOfContact.FlareBurner.key]: colors.orange.piazazz,
  [Enums.QualityOfContact.PoorlyUnder.key]: colors.blue.picton,
  [Enums.QualityOfContact.PoorlyTopped.key]: colors.green.vidaLoca,
  [Enums.QualityOfContact.PoorlyWeak.key]: colors.yellow.dolly,
  [Enums.QualityOfContact.Unidentified.key]: colors.grey.doveGray,

  hiddenSeries: 'transparent',
  default: colors.blue.default,
};
